import { render } from "./FacturacionNew.vue?vue&type=template&id=0ceb62d6&scoped=true"
import script from "./FacturacionNew.vue?vue&type=script&lang=js"
export * from "./FacturacionNew.vue?vue&type=script&lang=js"

import "./FacturacionNew.vue?vue&type=style&index=0&id=0ceb62d6&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ceb62d6"]])

export default __exports__